import { IApplicationState } from '../../types/redux';

export const promosSeoPageUrlSelector = (state: IApplicationState): string => {
  return `${state.newbuilding.fullUrl}akcii-i-skidki/`;
};
